<template>
  <section>
    <logged-in-header />
    <user-profile-panel class="UpPanel" />
    <empower-footer />
    <whats-app />
  </section>
</template>

<script>
import loggedInHeader from "../../components/commom/LoggedInHeader";
import empowerFooter from "../../components/commom/EmpowerFooter";
import UserProfilePanel from "../../components/user/UserProfilePanel";
import WhatsApp from "../../components/commom/WhatsApp";

export default {
  name: "UserProfile",

  components: {
    loggedInHeader,
    empowerFooter,
    UserProfilePanel,
    WhatsApp
  }
};
</script>

<style scoped>
.UpPanel {
  background-color: #e9e9e9;
}
</style>
